import React, { Component } from 'react'

export default class OnDataDeleteModal extends Component {
    render() {
        return (
            <div className='opacity-overlay ' style={{ 'display': 'block' }}>
                <div className="container">
                    <div className="popup-wrapper">
                        <div className="col-xs-12 col-sm-4 popup-content">
                            <div>
                                <div className='modal-header'>
                                    <h5 className="text-center" style={{ width: "100%" }}>Delete</h5>
                                </div>
                                <div className='modal-body'>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h5>Are you Sure you want to delete this {this.props.name}?</h5>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                {this.props.name==="Value" && <button type="button" className="form-control" style={{background: "red",color:"white"}} onClick={()=>this.props.onValueDelete(this.props.keys,this.props.index)}>Delete</button>}
                                                {this.props.name==="Benefit" && <button type="button" className="form-control" style={{background: "red",color:"white"}} onClick={()=>this.props.onBenefitsDelete(this.props.keys,this.props.index)}>Delete</button>}
                                                {this.props.name==="Attribute" && <button type="button" className="form-control" style={{background: "red",color:"white"}} onClick={()=>this.props.onAttributesDelete(this.props.keys,this.props.index)}>Delete</button>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <button type="button" className="form-control" onClick={()=>this.props.onDeleteModalClose()}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/BenefitsLadder/OnDataDeleteModal/OnDataDeleteModal.jsx